<div class="container mx-auto py-10">
  <!-- Header -->
  <div class="flex items-center justify-between space-y-2 mb-8">
    <div>
      <h2 class="text-3xl font-bold tracking-tight">Gestión de Tiendas</h2>
      <p class="text-muted-foreground">Administra todas las tiendas del sistema</p>
    </div>
    <button *ngIf="_auth.hasPermission('config.tiendas.create')"
      (click)="createNewShop()"
      class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
      Nueva Tienda
    </button>
  </div>

  <!-- Stats Cards -->
  <div *ngIf="!loading" class="grid gap-4 md:grid-cols-2 lg:grid-cols-5 mb-8">
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Total</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold">{{ stats.total }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Activas</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold text-green-600">{{ stats.active }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Inactivas</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold text-gray-600">{{ stats.inactive }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Registro</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold">{{ stats.withRegistration }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Compras</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold">{{ stats.withPurchases }}</div>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div *ngIf="!loading" class="rounded-lg border bg-card text-card-foreground shadow-sm mb-8">
    <div class="flex flex-col space-y-1.5 p-6">
      <h3 class="text-2xl font-semibold leading-none tracking-tight">Filtros</h3>
    </div>
    <div class="p-6 pt-0">
      <div class="grid gap-4 md:grid-cols-2">
        <div class="grid w-full items-center gap-1.5">
          <label class="text-sm font-medium leading-none">Buscar</label>
          <input 
            type="text"
            [(ngModel)]="filters.searchTerm"
            (input)="onFilterChange()"
            placeholder="Código, nombre, dirección..."
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
        </div>
        <div class="grid w-full items-center gap-1.5">
          <label class="text-sm font-medium leading-none">Estado</label>
          <select 
            [(ngModel)]="filters.status"
            (change)="onFilterChange()"
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <option value="all">Todas</option>
            <option value="active">Activas</option>
            <option value="inactive">Inactivas</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex items-center justify-center py-20">
    <div class="text-center">
      <div class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent"></div>
      <p class="mt-4 text-sm text-muted-foreground">Cargando tiendas...</p>
    </div>
  </div>

  <!-- Table -->
  <div *ngIf="!loading && shopsFiltered.length > 0" class="rounded-md border">
    <table class="w-full caption-bottom text-sm">
      <thead class="[&_tr]:border-b">
        <tr class="border-b transition-colors hover:bg-muted/50">
          <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Código</th>
          <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Nombre</th>
          <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Nombre Corto</th>
          <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Estado</th>
          <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">Acciones</th>
        </tr>
      </thead>
      <tbody class="[&_tr:last-child]:border-0">
        <tr 
          *ngFor="let shop of shopsPaginated"
          class="border-b transition-colors hover:bg-muted/50">
          <td class="p-4 align-middle font-medium">{{ shop.code }}</td>
          <td class="p-4 align-middle">
            <button
              (click)="viewShopDetail(shop)"
              class="text-left text-primary underline hover:text-primary/80 transition-colors cursor-pointer">
              {{ shop.name }}
            </button>
          </td>
          <td class="p-4 align-middle">{{ shop.short_name || '-' }}</td>
          <td class="p-4 align-middle">
            <div 
              class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold"
              [ngClass]="shop.status ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'">
              {{ getStatusText(shop.status) }}
            </div>
          </td>
          <td class="p-4 align-middle">
            <div class="flex justify-center relative">
              <!-- Trigger Button -->
              <button *ngIf="_auth.hasPermission('config.tiendas.update')"
                (click)="togglePopover(shop.code); $event.stopPropagation()"
                class="popover-trigger inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
                  <circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/>
                </svg>
              </button>

              <!-- Popover Content -->
              <div 
                *ngIf="isPopoverOpen(shop.code)"
                class="popover-content absolute right-0 top-10 z-50 w-56 rounded-md border bg-popover p-1 text-popover-foreground shadow-md outline-none animate-in fade-in-0 zoom-in-95">
                <div class="flex flex-col gap-1">
                  <button
                    (click)="viewShopDetail(shop)"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
                      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>
                    </svg>
                    Ver Detalle
                  </button>
                  <button
                    (click)="openEditModal(shop)"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
                      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/><path d="m15 5 4 4"/>
                    </svg>
                    Editar
                  </button>
                  <button
                    (click)="openCashRegistersModal(shop)"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
                      <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
                    </svg>
                    Gestionar Cajas
                  </button>
                  <div class="h-px bg-border my-1"></div>
                  <button
                    (click)="toggleShopStatus(shop, $event)"
                    [ngClass]="shop.status ? 'text-destructive hover:bg-destructive/10' : 'text-green-600 hover:bg-green-50'"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg *ngIf="shop.status" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
                      <circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>
                    </svg>
                    <svg *ngIf="!shop.status" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                    </svg>
                    {{ shop.status ? 'Inactivar' : 'Activar' }}
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div *ngIf="!loading && shopsFiltered.length > 0" class="flex items-center justify-between px-2 py-4">
    <div class="text-sm text-muted-foreground">
      Mostrando {{ (currentPage - 1) * pageSize + 1 }} a {{ Math.min(currentPage * pageSize, shopsFiltered.length) }} de {{ shopsFiltered.length }} tiendas
    </div>
    <div class="flex items-center space-x-2">
      <button
        (click)="previousPage()"
        [disabled]="currentPage === 1"
        class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="m15 18-6-6 6-6"/></svg>
        Anterior
      </button>
      <div class="flex items-center gap-1">
        <span class="text-sm font-medium">Página {{ currentPage }} de {{ totalPages }}</span>
      </div>
      <button
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
        Siguiente
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="m9 18 6-6-6-6"/></svg>
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && shopsFiltered.length === 0" class="text-center py-20">
    <h3 class="text-xl font-semibold">{{ hasActiveFilters() ? 'No se encontraron tiendas' : 'No hay tiendas registradas' }}</h3>
    <p class="text-sm text-muted-foreground mt-2">
      {{ hasActiveFilters() ? 'No hay tiendas que coincidan con los filtros.' : 'Comienza creando tu primera tienda.' }}
    </p>
    <button 
      *ngIf="!hasActiveFilters()"
      (click)="createNewShop()"
      class="mt-4 inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
      Crear Primera Tienda
    </button>
  </div>
</div>

<!-- Modal -->
<div *ngIf="showModal" class="fixed inset-0 z-50 bg-black/80" (click)="closeModal()">
  <div class="fixed left-[50%] top-[50%] z-50 grid w-full max-w-4xl translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg sm:rounded-lg max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex flex-col space-y-1.5 border-b pb-4">
      <h2 class="text-xl font-semibold">Detalles de la Tienda</h2>
      <p class="text-sm text-muted-foreground">Información completa de la tienda</p>
    </div>

    <div *ngIf="selectedShop" class="space-y-6">
      <!-- Información Básica -->
      <div class="space-y-4">
        <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"/><path d="m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9"/><path d="M12 3v6"/>
          </svg>
          Información Básica
        </h3>
        
        <div class="space-y-4">
          <!-- Código -->
          <div>
            <label class="text-xs font-medium text-muted-foreground uppercase tracking-wide">Código</label>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-sm font-semibold">{{ selectedShop.code }}</p>
              <button
                (click)="copyToClipboard(selectedShop.code, 'Código')"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-7 w-7"
                title="Copiar código">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Nombre -->
          <div>
            <label class="text-xs font-medium text-muted-foreground uppercase tracking-wide">Nombre</label>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-sm">{{ selectedShop.name }}</p>
              <button
                (click)="copyToClipboard(selectedShop.name, 'Nombre')"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-7 w-7"
                title="Copiar nombre">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Nombre Corto -->
          <div *ngIf="selectedShop.short_name">
            <label class="text-xs font-medium text-muted-foreground uppercase tracking-wide">Nombre Corto</label>
            <div class="flex items-center gap-2 mt-1">
              <p class="text-sm">{{ selectedShop.short_name }}</p>
              <button
                (click)="copyToClipboard(selectedShop.short_name, 'Nombre Corto')"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-7 w-7"
                title="Copiar nombre corto">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Estado -->
          <div class="space-y-1.5">
            <label class="text-xs font-medium text-muted-foreground uppercase tracking-wide">Estado</label>
            <div>
              <div 
                class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold"
                [ngClass]="selectedShop.status ? 'bg-green-100 text-green-800 border-green-200' : 'bg-gray-100 text-gray-800 border-gray-200'">
                {{ getStatusText(selectedShop.status) }}
              </div>
            </div>
          </div>

          <!-- Dirección -->
          <div *ngIf="selectedShop.address" class="space-y-1.5">
            <label class="text-xs font-medium text-muted-foreground uppercase tracking-wide">Dirección</label>
            <div class="flex items-start gap-2">
              <p class="text-sm">{{ selectedShop.address }}</p>
              <button
                (click)="copyToClipboard(selectedShop.address, 'Dirección')"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-7 w-7 flex-shrink-0"
                title="Copiar dirección">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Descripción -->
          <div *ngIf="selectedShop.description" class="space-y-1.5">
            <label class="text-xs font-medium text-muted-foreground uppercase tracking-wide">Descripción</label>
            <div class="flex items-start gap-2">
              <p class="text-sm">{{ selectedShop.description }}</p>
              <button
                (click)="copyToClipboard(selectedShop.description, 'Descripción')"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-7 w-7 flex-shrink-0"
                title="Copiar descripción">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Características -->
      <div class="space-y-3">
        <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>
          </svg>
          Características
        </h3>
        <div class="flex flex-wrap gap-2" *ngIf="selectedShop.register_clients || selectedShop.available_purchases || selectedShop.visibility; else noCharacteristics">
          <div *ngIf="selectedShop.register_clients" class="inline-flex items-center rounded-md bg-blue-100 text-blue-800 border border-blue-200 px-2.5 py-0.5 text-xs font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
            </svg>
            Registro de Clientes
          </div>
          <div *ngIf="selectedShop.available_purchases" class="inline-flex items-center rounded-md bg-green-100 text-green-800 border border-green-200 px-2.5 py-0.5 text-xs font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1">
              <circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
            </svg>
            Compras Disponibles
          </div>
          <div *ngIf="selectedShop.visibility" class="inline-flex items-center rounded-md bg-purple-100 text-purple-800 border border-purple-200 px-2.5 py-0.5 text-xs font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1">
              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>
            </svg>
            Visible para Clientes
          </div>
        </div>
        <ng-template #noCharacteristics>
          <p class="text-sm text-muted-foreground italic">No hay características habilitadas</p>
        </ng-template>
      </div>

      <!-- Personal de la Tienda -->
      <div *ngIf="selectedShop.personal && selectedShop.personal.length > 0" class="space-y-3">
        <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          Personal de la Tienda
        </h3>
        <div class="rounded-md border">
          <table class="w-full caption-bottom text-sm">
            <thead class="border-b bg-muted/50">
              <tr class="border-b transition-colors">
                <th class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">Nombre</th>
                <th class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">Apellido</th>
                <th class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">Teléfono</th>
                <th class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">Email</th>
                <th class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">Cargo</th>
              </tr>
            </thead>
            <tbody class="[&_tr:last-child]:border-0">
              <tr *ngFor="let person of selectedShop.personal" class="border-b transition-colors hover:bg-muted/50">
                <td class="p-3 align-middle">
                  <div class="flex items-center gap-2">
                    <span class="text-sm">{{ person.name }}</span>
                    <button
                      (click)="copyToClipboard(person.name, 'Nombre')"
                      class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6"
                      title="Copiar nombre">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                      </svg>
                    </button>
                  </div>
                </td>
                <td class="p-3 align-middle">
                  <div class="flex items-center gap-2">
                    <span class="text-sm">{{ person.lastname }}</span>
                    <button
                      (click)="copyToClipboard(person.lastname, 'Apellido')"
                      class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6"
                      title="Copiar apellido">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                      </svg>
                    </button>
                  </div>
                </td>
                <td class="p-3 align-middle">
                  <div class="flex items-center gap-2" *ngIf="person.phone">
                    <span class="text-sm">+58 {{ person.phone }}</span>
                    <button
                      (click)="copyToClipboard('+58' + person.phone, 'Teléfono')"
                      class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6"
                      title="Copiar teléfono">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                      </svg>
                    </button>
                  </div>
                  <span *ngIf="!person.phone" class="text-xs text-muted-foreground italic">No especificado</span>
                </td>
                <td class="p-3 align-middle">
                  <div class="flex items-center gap-2" *ngIf="person.email">
                    <span class="text-sm break-all">{{ person.email }}</span>
                    <button
                      (click)="copyToClipboard(person.email, 'Email')"
                      class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6 flex-shrink-0"
                      title="Copiar email">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                      </svg>
                    </button>
                  </div>
                  <span *ngIf="!person.email" class="text-xs text-muted-foreground italic">No especificado</span>
                </td>
                <td class="p-3 align-middle">
                  <div class="flex items-center gap-2">
                    <div class="inline-flex items-center rounded-md border bg-primary/10 text-primary px-2 py-0.5 text-xs font-semibold">
                      {{ person.position }}
                    </div>
                    <button
                      (click)="copyToClipboard(person.position, 'Cargo')"
                      class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6"
                      title="Copiar cargo">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- Mensaje si no hay personal -->
      <div *ngIf="!selectedShop.personal || selectedShop.personal.length === 0" class="space-y-3">
        <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          Personal de la Tienda
        </h3>
        <div class="rounded-md border border-dashed p-6 text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mx-auto mb-2 text-muted-foreground opacity-50">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <p class="text-sm text-muted-foreground">No hay personal registrado en esta tienda</p>
        </div>
      </div>
    </div>
    <div class="flex justify-between items-center">
      <!-- Botón Ver Responsable -->
      <div class="relative">
        <button
          *ngIf="selectedShop?.responsible"
          (click)="toggleResponsiblePopover(); $event.stopPropagation()"
          class="popover-trigger inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          Ver Responsable
        </button>
        
        <!-- Popover de Responsable -->
        <div 
          *ngIf="showResponsiblePopover && selectedShop?.responsible"
          class="popover-content absolute left-0 bottom-12 z-50 w-80 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none animate-in fade-in-0 zoom-in-95">
          <div class="space-y-3">
            <div class="flex items-center justify-between border-b pb-2">
              <h3 class="font-semibold text-sm">Responsable de la Tienda</h3>
              <button
                (click)="toggleResponsiblePopover()"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                </svg>
              </button>
            </div>
            
            <div class="space-y-2">
              <div>
                <label class="text-xs font-medium text-muted-foreground">Nombre Completo</label>
                <div class="flex items-center gap-2 mt-1">
                  <p class="text-sm">{{ selectedShop.responsible.name }} {{ selectedShop.responsible.lastname }}</p>
                  <button
                    (click)="copyToClipboard(selectedShop.responsible.name + ' ' + selectedShop.responsible.lastname, 'Nombre')"
                    class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                    </svg>
                  </button>
                </div>
              </div>
              
              <div>
                <label class="text-xs font-medium text-muted-foreground">Teléfono</label>
                <div class="flex items-center gap-2 mt-1">
                  <p class="text-sm">+58 {{ selectedShop.responsible.phone }}</p>
                  <button
                    (click)="copyToClipboard('+58' + selectedShop.responsible.phone, 'Teléfono')"
                    class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                    </svg>
                  </button>
                </div>
              </div>
              
              <div>
                <label class="text-xs font-medium text-muted-foreground">Email</label>
                <div class="flex items-center gap-2 mt-1">
                  <p class="text-sm break-all">{{ selectedShop.responsible.email }}</p>
                  <button
                    (click)="copyToClipboard(selectedShop.responsible.email, 'Email')"
                    class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                    </svg>
                  </button>
                </div>
              </div>
              
              <div>
                <label class="text-xs font-medium text-muted-foreground">Cargo</label>
                <div class="flex items-center gap-2 mt-1">
                  <div class="inline-flex items-center rounded-md border bg-primary/10 text-primary px-2.5 py-0.5 text-xs font-semibold">
                    {{ selectedShop.responsible.position }}
                  </div>
                  <button
                    (click)="copyToClipboard(selectedShop.responsible.position, 'Cargo')"
                    class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-6 w-6">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <button
        (click)="closeModal()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Crear/Editar Tienda -->
<div *ngIf="showFormModal" class="fixed inset-0 z-50 bg-black/80" (click)="closeFormModal()">
  <div class="fixed left-[50%] top-[50%] z-50 w-full translate-x-[-50%] translate-y-[-50%] border bg-background shadow-lg duration-200 sm:rounded-lg" 
       [ngClass]="isEditingShop ? 'max-w-4xl' : 'max-w-2xl'"
       (click)="$event.stopPropagation()">
    
    <!-- Dialog Header -->
    <div class="flex flex-col space-y-1.5 text-center sm:text-left p-6 pb-4">
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <h2 class="text-lg font-semibold leading-none tracking-tight">
            {{ isEditingShop ? (currentStep === 1 ? 'Editar Tienda' : 'Gestión de Personal') : (currentStep === 1 ? 'Nueva Tienda' : 'Personal de la Tienda') }}
          </h2>
          <p class="text-sm text-muted-foreground">
            {{ isEditingShop ? (currentStep === 1 ? 'Modifica los datos de la tienda' : 'Administra el personal de la tienda') : (currentStep === 1 ? 'Completa los datos para crear una nueva tienda' : 'Agrega personas al personal (opcional)') }}
          </p>
        </div>
        <!-- Badge para ir a Gestión de Personal (solo en edición, paso 1) -->
        <button
          *ngIf="isEditingShop && currentStep === 1"
          (click)="currentStep = 2"
          class="inline-flex items-center gap-2 rounded-full bg-primary/10 text-primary hover:bg-primary/20 px-4 py-2 text-sm font-medium transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          Gestionar Personal
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Dialog Content -->
    <div class="px-6 max-h-[calc(90vh-180px)] overflow-y-auto">
      
      <!-- Progress Steps (solo para crear) -->
      <div *ngIf="!isEditingShop" class="flex items-center justify-center gap-2 py-2 mb-4">
      <div class="flex items-center">
        <div [ngClass]="currentStep >= 1 ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'" 
             class="flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium">
          1
        </div>
        <span class="ml-2 text-sm font-medium" [ngClass]="currentStep >= 1 ? 'text-foreground' : 'text-muted-foreground'">
          Datos de Tienda
        </span>
      </div>
      <div class="h-px w-12 bg-border"></div>
      <div class="flex items-center">
        <div [ngClass]="currentStep >= 2 ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'" 
             class="flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium">
          2
        </div>
        <span class="ml-2 text-sm font-medium" [ngClass]="currentStep >= 2 ? 'text-foreground' : 'text-muted-foreground'">
          Personal
        </span>
      </div>
    </div>

    <!-- Form -->
    <div class="grid gap-4">
      <!-- Paso 1: Datos de la Tienda -->
      <div *ngIf="currentStep === 1" class="grid gap-4">
      <!-- Código y Nombre -->
      <div class="grid grid-cols-2 gap-4">
        <div class="grid w-full items-center gap-1.5">
          <label for="code" class="text-sm font-medium leading-none">Código *</label>
          <input 
            id="code"
            type="text"
            [(ngModel)]="formData.code"
            [disabled]="isEditingShop"
            placeholder="1001"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
        </div>
        <div class="grid w-full items-center gap-1.5">
          <label for="name" class="text-sm font-medium leading-none">Nombre *</label>
          <input 
            id="name"
            type="text"
            [(ngModel)]="formData.name"
            placeholder="SUCURSAL 01 Catia"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
        </div>
      </div>

      <!-- Nombre Corto -->
      <div class="grid w-full items-center gap-1.5">
        <label for="short_name" class="text-sm font-medium leading-none">Nombre Corto</label>
        <input 
          id="short_name"
          type="text"
          [(ngModel)]="formData.short_name"
          placeholder="Catia"
          class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
      </div>

      <!-- Dirección -->
      <div class="grid w-full items-center gap-1.5">
        <label for="address" class="text-sm font-medium leading-none">Dirección</label>
        <textarea 
          id="address"
          [(ngModel)]="formData.address"
          placeholder="Av. España con Panamérica..."
          rows="2"
          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"></textarea>
      </div>

      <!-- Descripción -->
      <div class="grid w-full items-center gap-1.5">
        <label for="description" class="text-sm font-medium leading-none">Descripción</label>
        <textarea 
          id="description"
          [(ngModel)]="formData.description"
          placeholder="Descripción de la tienda..."
          rows="2"
          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"></textarea>
      </div>

      <!-- Características -->
      <div class="grid w-full items-center gap-2">
        <label class="text-sm font-medium leading-none">Características</label>
        
        <div class="flex items-center space-x-2">
          <input 
            type="checkbox"
            id="register_clients"
            [(ngModel)]="formData.register_clients"
            class="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
          <label for="register_clients" class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            Permitir registro de clientes
          </label>
        </div>

        <div class="flex items-center space-x-2">
          <input 
            type="checkbox"
            id="available_purchases"
            [(ngModel)]="formData.available_purchases"
            class="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
          <label for="available_purchases" class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            Compras disponibles
          </label>
        </div>

        <div class="flex items-center space-x-2">
          <input 
            type="checkbox"
            id="visibility"
            [(ngModel)]="formData.visibility"
            class="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
          <label for="visibility" class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            Visible para clientes
          </label>
        </div>

        <div class="flex items-center space-x-2">
          <input 
            type="checkbox"
            id="status"
            [(ngModel)]="formData.status"
            class="peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
          <label for="status" class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            Tienda activa
          </label>
        </div>
      </div>
      </div>
      <!-- Fin Paso 1 -->
      
      <!-- Paso 2: Gestión de Personal (solo para editar) -->
      <div *ngIf="currentStep === 2 && isEditingShop" class="space-y-4">
        <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          Gestión de Personal
        </h3>
        
        <!-- Formulario para agregar persona -->
        <div class="border rounded-lg p-4 bg-muted/30 space-y-3">
          <p class="text-xs font-medium text-muted-foreground">Agregar nueva persona</p>
          
          <!-- Cargo -->
          <div class="grid w-full items-center gap-1.5">
            <label for="edit_position" class="text-sm font-medium leading-none">Cargo *</label>
            <select 
              id="edit_position"
              [(ngModel)]="currentPerson.position"
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
              <option value="" disabled selected>Selecciona un cargo</option>
              <option value="Otro">Otro</option>
              <option value="Supervisor">Supervisor</option>
              <option value="Gerente">Gerente</option>
            </select>
          </div>

          <!-- Input para cargo personalizado -->
          <div *ngIf="currentPerson.position === 'Otro'" class="grid w-full items-center gap-1.5">
            <label for="edit_custom_position" class="text-sm font-medium leading-none">Especifica el cargo *</label>
            <input 
              id="edit_custom_position"
              type="text"
              [(ngModel)]="currentPerson.custom_position"
              placeholder="Ej: Asistente, Cajero, etc."
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
          </div>

          <!-- Nombre y Apellido -->
          <div class="grid grid-cols-2 gap-4">
            <div class="grid w-full items-center gap-1.5">
              <label for="edit_person_name" class="text-sm font-medium leading-none">Nombre *</label>
              <input 
                id="edit_person_name"
                type="text"
                [(ngModel)]="currentPerson.name"
                placeholder="Juan"
                class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            </div>
            <div class="grid w-full items-center gap-1.5">
              <label for="edit_person_lastname" class="text-sm font-medium leading-none">Apellido *</label>
              <input 
                id="edit_person_lastname"
                type="text"
                [(ngModel)]="currentPerson.lastname"
                placeholder="Pérez"
                class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            </div>
          </div>

          <!-- Teléfono y Email -->
          <div class="grid grid-cols-2 gap-4">
            <div class="grid w-full items-center gap-1.5">
              <label for="edit_person_phone" class="text-sm font-medium leading-none">Teléfono</label>
              <div class="flex h-9 w-full rounded-md border border-input bg-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2">
                <span class="inline-flex items-center px-3 text-sm text-muted-foreground border-r border-input bg-muted">+58</span>
                <input 
                  id="edit_person_phone"
                  type="tel"
                  [(ngModel)]="currentPerson.phone"
                  (input)="validatePhone($event)"
                  maxlength="10"
                  placeholder="4121234567"
                  class="flex-1 bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none">
              </div>
            </div>
            <div class="grid w-full items-center gap-1.5">
              <label for="edit_person_email" class="text-sm font-medium leading-none">Correo Electrónico</label>
              <input 
                id="edit_person_email"
                type="email"
                [(ngModel)]="currentPerson.email"
                placeholder="juan.perez@example.com"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            </div>
          </div>

          <!-- Botón Agregar -->
          <button
            (click)="isEditingShop ? addOrUpdateEditingPerson() : addPerson()"
            class="w-full inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-9 px-4 py-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
              <path d="M5 12h14"/><path d="M12 5v14"/>
            </svg>
            Agregar Persona
          </button>
        </div>

        <!-- Lista de personal -->
        <div *ngIf="(isEditingShop ? editingPersonal : personal).length > 0" class="space-y-2">
          <h4 class="text-sm font-medium">Personal Actual ({{ (isEditingShop ? editingPersonal : personal).length }})</h4>
          <div class="rounded-md border">
            <table class="w-full caption-bottom text-sm">
              <thead class="border-b bg-muted/50">
                <tr>
                  <th class="h-10 px-3 text-left align-middle font-medium text-muted-foreground text-xs">Nombre</th>
                  <th class="h-10 px-3 text-left align-middle font-medium text-muted-foreground text-xs">Teléfono</th>
                  <th class="h-10 px-3 text-left align-middle font-medium text-muted-foreground text-xs">Email</th>
                  <th class="h-10 px-3 text-left align-middle font-medium text-muted-foreground text-xs">Cargo</th>
                  <th class="h-10 px-3 text-center align-middle font-medium text-muted-foreground text-xs">Acciones</th>
                </tr>
              </thead>
              <tbody class="[&_tr:last-child]:border-0">
                <tr *ngFor="let person of (isEditingShop ? editingPersonal : personal); let i = index" 
                    class="border-b transition-colors"
                    [ngClass]="{'bg-primary/5': editingPersonInline === i}">
                  
                  <!-- Modo Vista -->
                  <ng-container *ngIf="editingPersonInline !== i">
                    <td class="p-3 align-middle">
                      <div class="flex flex-col">
                        <span class="text-sm font-medium">{{ person.name }} {{ person.lastname }}</span>
                      </div>
                    </td>
                    <td class="p-3 align-middle">
                      <span class="text-sm" *ngIf="person.phone">+58 {{ person.phone }}</span>
                      <span class="text-xs text-muted-foreground italic" *ngIf="!person.phone">-</span>
                    </td>
                    <td class="p-3 align-middle">
                      <span class="text-sm break-all" *ngIf="person.email">{{ person.email }}</span>
                      <span class="text-xs text-muted-foreground italic" *ngIf="!person.email">-</span>
                    </td>
                    <td class="p-3 align-middle">
                      <div class="inline-flex items-center rounded-md border bg-primary/10 text-primary px-2 py-0.5 text-xs font-semibold">
                        {{ person.position }}
                      </div>
                    </td>
                    <td class="p-3 align-middle">
                      <div class="flex justify-center gap-1">
                        <button
                          (click)="startInlineEdit(i)"
                          class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-accent h-8 w-8"
                          title="Editar">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/><path d="m15 5 4 4"/>
                          </svg>
                        </button>
                        <button
                          (click)="isEditingShop ? removeEditingPerson(i) : removePerson(i)"
                          class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-destructive/10 hover:text-destructive h-8 w-8"
                          title="Eliminar">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Modo Edición Inline -->
                  <ng-container *ngIf="editingPersonInline === i">
                    <td class="p-2 align-middle">
                      <div class="grid grid-cols-2 gap-2">
                        <input 
                          type="text"
                          [(ngModel)]="tempPersonData.name"
                          placeholder="Nombre"
                          class="flex h-8 w-full rounded-md border border-input bg-background px-2 py-1 text-sm">
                        <input 
                          type="text"
                          [(ngModel)]="tempPersonData.lastname"
                          placeholder="Apellido"
                          class="flex h-8 w-full rounded-md border border-input bg-background px-2 py-1 text-sm">
                      </div>
                    </td>
                    <td class="p-2 align-middle">
                      <input 
                        type="tel"
                        [(ngModel)]="tempPersonData.phone"
                        (input)="validatePhone($event)"
                        maxlength="10"
                        placeholder="4121234567"
                        class="flex h-8 w-full rounded-md border border-input bg-background px-2 py-1 text-sm">
                    </td>
                    <td class="p-2 align-middle">
                      <input 
                        type="email"
                        [(ngModel)]="tempPersonData.email"
                        placeholder="email@example.com"
                        class="flex h-8 w-full rounded-md border border-input bg-background px-2 py-1 text-sm">
                    </td>
                    <td class="p-2 align-middle">
                      <input 
                        type="text"
                        [(ngModel)]="tempPersonData.position"
                        placeholder="Cargo"
                        class="flex h-8 w-full rounded-md border border-input bg-background px-2 py-1 text-sm">
                    </td>
                    <td class="p-2 align-middle">
                      <div class="flex justify-center gap-1">
                        <button
                          (click)="confirmInlineEdit(i)"
                          class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-green-100 hover:bg-green-200 text-green-700 h-8 w-8"
                          title="Guardar">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                        </button>
                        <button
                          (click)="cancelInlineEdit()"
                          class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-destructive/10 hover:text-destructive h-8 w-8"
                          title="Cancelar">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Empty state -->
        <div *ngIf="(isEditingShop ? editingPersonal : personal).length === 0" class="rounded-md border border-dashed p-6 text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mx-auto mb-2 text-muted-foreground opacity-50">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <p class="text-sm text-muted-foreground">No hay personal registrado</p>
          <p class="text-xs text-muted-foreground mt-1">Agrega personas usando el formulario de arriba</p>
        </div>
      </div>
      </div>
      <!-- Fin Paso 1 -->

      <!-- Paso 2: Personal de la Tienda (solo para crear) -->
      <div *ngIf="currentStep === 2 && !isEditingShop" class="grid gap-4">
        <div class="flex items-center justify-between">
          <div>
            <h3 class="text-sm font-semibold">Personal de la Tienda (Opcional)</h3>
            <p class="text-xs text-muted-foreground">Agrega personas al personal de la tienda</p>
          </div>
          <span class="text-xs text-muted-foreground">{{ personal.length }} persona(s)</span>
        </div>

        <!-- Formulario para agregar persona -->
        <div class="border rounded-lg p-4 bg-muted/30 space-y-3">
          <!-- Cargo -->
          <div class="grid w-full items-center gap-1.5">
            <label for="position" class="text-sm font-medium leading-none">Cargo *</label>
            <select 
              id="position"
              [(ngModel)]="currentPerson.position"
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
              <option value="" disabled selected>Selecciona un cargo</option>
              <option value="Otro">Otro</option>
              <option value="Supervisor">Supervisor</option>
              <option value="Gerente">Gerente</option>
            </select>
          </div>

          <!-- Input para cargo personalizado (solo si selecciona "Otro") -->
          <div *ngIf="currentPerson.position === 'Otro'" class="grid w-full items-center gap-1.5">
            <label for="custom_position" class="text-sm font-medium leading-none">Especifica el cargo *</label>
            <input 
              id="custom_position"
              type="text"
              [(ngModel)]="currentPerson.custom_position"
              placeholder="Ej: Asistente, Cajero, etc."
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
          </div>

          <!-- Nombre y Apellido -->
          <div class="grid grid-cols-2 gap-4">
            <div class="grid w-full items-center gap-1.5">
              <label for="person_name" class="text-sm font-medium leading-none">Nombre *</label>
              <input 
                id="person_name"
                type="text"
                [(ngModel)]="currentPerson.name"
                placeholder="Juan"
                class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            </div>
            <div class="grid w-full items-center gap-1.5">
              <label for="person_lastname" class="text-sm font-medium leading-none">Apellido *</label>
              <input 
                id="person_lastname"
                type="text"
                [(ngModel)]="currentPerson.lastname"
                placeholder="Pérez"
                class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            </div>
          </div>

          <!-- Teléfono y Email -->
          <div class="grid grid-cols-2 gap-4">
            <div class="grid w-full items-center gap-1.5">
              <label for="person_phone" class="text-sm font-medium leading-none">Teléfono</label>
              <div class="flex h-9 w-full rounded-md border border-input bg-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2">
                <span class="inline-flex items-center px-3 text-sm text-muted-foreground border-r border-input bg-muted">+58</span>
                <input 
                  id="person_phone"
                  type="tel"
                  [(ngModel)]="currentPerson.phone"
                  (input)="validatePhone($event)"
                  maxlength="10"
                  placeholder="4121234567"
                  class="flex-1 bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none">
              </div>
            </div>
            <div class="grid w-full items-center gap-1.5">
              <label for="person_email" class="text-sm font-medium leading-none">Correo Electrónico</label>
              <input 
                id="person_email"
                type="email"
                [(ngModel)]="currentPerson.email"
                placeholder="juan.perez@example.com"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            </div>
          </div>

          <!-- Botón Agregar -->
          <button
            (click)="addPerson()"
            class="w-full inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-9 px-4 py-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
              <path d="M5 12h14"/><path d="M12 5v14"/>
            </svg>
            Agregar Persona
          </button>
        </div>

        <!-- Lista de personal agregado -->
        <div *ngIf="personal.length > 0" class="space-y-2">
          <h4 class="text-sm font-medium">Personal Agregado:</h4>
          <div class="space-y-2">
            <div *ngFor="let person of personal; let i = index" 
                 class="flex items-center justify-between p-3 border rounded-lg bg-background">
              <div class="flex-1">
                <p class="text-sm font-medium">{{ person.name }} {{ person.lastname }}</p>
                <div class="flex gap-2 mt-1">
                  <span class="inline-flex items-center rounded-md border bg-primary/10 text-primary px-2 py-0.5 text-xs font-semibold">
                    {{ person.position }}
                  </span>
                  <span *ngIf="person.phone" class="text-xs text-muted-foreground">+58 {{ person.phone }}</span>
                  <span *ngIf="person.email" class="text-xs text-muted-foreground">{{ person.email }}</span>
                </div>
              </div>
              <button
                (click)="removePerson(i)"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium hover:bg-destructive/10 hover:text-destructive h-8 w-8">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin Paso 2 -->
      
    </div>
    <!-- Fin Dialog Content -->

    <!-- Dialog Footer -->
    <div class="flex items-center justify-between p-6 pt-4 border-t">
      <!-- Botón Anterior (paso 2) -->
      <button
        *ngIf="currentStep === 2"
        (click)="previousStep()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
          <path d="m15 18-6-6 6-6"/>
        </svg>
        Atrás
      </button>
      
      <div class="flex gap-2" [ngClass]="currentStep === 1 ? 'ml-auto' : ''">
        <button
          (click)="closeFormModal()"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
          Cancelar
        </button>
        
        <!-- Botón Siguiente (paso 1 al crear) -->
        <button
          *ngIf="currentStep === 1 && !isEditingShop"
          (click)="nextStep()"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
          Siguiente
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ml-2 h-4 w-4">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </button>
        
        <!-- Botón Guardar -->
        <button
          *ngIf="currentStep === 2 || (currentStep === 1 && isEditingShop)"
          (click)="saveShop()"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
          {{ isEditingShop ? 'Guardar Cambios' : 'Crear Tienda' }}
        </button>
      </div>
    </div>
    <!-- Fin Dialog Footer -->
    
  </div>
</div>

<!-- ========================================
     MODALES DE GESTIÓN DE CAJAS
     ======================================== -->

<!-- Modal de Gestión de Cajas -->
<div *ngIf="showCashRegistersModal" class="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
  <div class="bg-background rounded-lg shadow-lg w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col">
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b">
      <div>
        <h3 class="text-lg font-semibold">Gestión de Cajas</h3>
        <p class="text-sm text-muted-foreground mt-1">
          Tienda: <span class="font-medium">{{ selectedShopForCashRegisters?.name }}</span> ({{ selectedShopForCashRegisters?.code }})
        </p>
      </div>
      <button (click)="closeCashRegistersModal()" class="rounded-sm opacity-70 hover:opacity-100 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto p-6">
      <!-- Botón crear -->
      <div class="mb-6">
        <button 
          (click)="createNewCashRegister()"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
            <path d="M5 12h14"/><path d="M12 5v14"/>
          </svg>
          Nueva Caja
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="loadingCashRegisters" class="flex justify-center py-12">
        <div class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent"></div>
      </div>

      <!-- Lista de cajas -->
      <div *ngIf="!loadingCashRegisters && cashRegisters.length > 0" class="rounded-md border">
        <table class="w-full caption-bottom text-sm">
          <thead class="[&_tr]:border-b">
            <tr class="border-b transition-colors hover:bg-muted/50">
              <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Número</th>
              <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Afiliación</th>
              <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Tipo</th>
              <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Descripción</th>
              <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Estado</th>
              <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">Acciones</th>
            </tr>
          </thead>
          <tbody class="[&_tr:last-child]:border-0">
            <tr *ngFor="let cr of cashRegisters" class="border-b transition-colors hover:bg-muted/50">
              <td class="p-4 align-middle">
                <span class="font-semibold text-primary">#{{ cr.cash_register_number }}</span>
              </td>
              <td class="p-4 align-middle font-mono text-sm">{{ cr.afiliation_number }}</td>
              <td class="p-4 align-middle">
                <span [ngClass]="cr.type === 'AUTOPAGO' ? 'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold bg-blue-100 text-blue-800' : 'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold bg-gray-100 text-gray-800'">
                  {{ cr.type }}
                </span>
              </td>
              <td class="p-4 align-middle text-sm text-muted-foreground">
                {{ cr.description || '-' }}
              </td>
              <td class="p-4 align-middle">
                <span [ngClass]="cr.status ? 'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold bg-green-100 text-green-800' : 'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold bg-red-100 text-red-800'">
                  {{ cr.status ? 'Activa' : 'Inactiva' }}
                </span>
              </td>
              <td class="p-4 align-middle">
                <div class="flex justify-center gap-2">
                  <button 
                    (click)="editCashRegister(cr)" 
                    class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9"
                    title="Editar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/><path d="m15 5 4 4"/>
                    </svg>
                  </button>
                  <button 
                    (click)="deleteCashRegister(cr)" 
                    class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-destructive/10 text-destructive h-9 w-9"
                    title="Eliminar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loadingCashRegisters && cashRegisters.length === 0" class="text-center py-16 bg-muted/20 rounded-lg border-2 border-dashed">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="mx-auto mb-4 text-muted-foreground opacity-50">
          <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
        </svg>
        <h3 class="text-lg font-semibold mb-2">No hay cajas registradas</h3>
        <p class="text-sm text-muted-foreground mb-6">Comienza agregando la primera caja para esta tienda</p>
        <button 
          (click)="createNewCashRegister()"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
            <path d="M5 12h14"/><path d="M12 5v14"/>
          </svg>
          Agregar Primera Caja
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Formulario de Caja -->
<div *ngIf="showCashRegisterFormModal" class="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4">
  <div class="bg-background rounded-lg shadow-lg w-full max-w-md">
    <div class="flex items-center justify-between p-6 border-b">
      <h3 class="text-lg font-semibold">{{ isEditingCashRegister ? 'Editar' : 'Nueva' }} Caja</h3>
      <button (click)="showCashRegisterFormModal = false" class="rounded-sm opacity-70 hover:opacity-100 transition-opacity">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
    
    <div class="p-6 space-y-4">
      <div class="grid w-full items-center gap-1.5">
        <label class="text-sm font-medium leading-none">Número de Caja <span class="text-destructive">*</span></label>
        <input 
          type="number" 
          [(ngModel)]="cashRegisterFormData.cash_register_number"
          [disabled]="isEditingCashRegister"
          placeholder="1, 2, 3..."
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
        <p class="text-xs text-muted-foreground">Identificador único de la caja en la tienda</p>
      </div>

      <div class="grid w-full items-center gap-1.5">
        <label class="text-sm font-medium leading-none">Número de Afiliación <span class="text-destructive">*</span></label>
        <input 
          type="text" 
          [(ngModel)]="cashRegisterFormData.afiliation_number"
          placeholder="Ej: 12345678"
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
        <p class="text-xs text-muted-foreground">Número único que se agregará a la referencia del pago</p>
      </div>

      <div class="grid w-full items-center gap-1.5">
        <label class="text-sm font-medium leading-none">Tipo de Caja <span class="text-destructive">*</span></label>
        <select 
          [(ngModel)]="cashRegisterFormData.type"
          class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
          <option value="NORMAL">Normal</option>
          <option value="AUTOPAGO">Autopago</option>
        </select>
        <p class="text-xs text-muted-foreground">Tipo de caja para identificación en reportes</p>
      </div>

      <div class="grid w-full items-center gap-1.5">
        <label class="text-sm font-medium leading-none">Descripción</label>
        <textarea 
          [(ngModel)]="cashRegisterFormData.description"
          rows="3"
          placeholder="Información adicional sobre la caja..."
          class="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"></textarea>
      </div>
    </div>

    <div class="flex justify-end gap-2 p-6 border-t">
      <button 
        (click)="showCashRegisterFormModal = false"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
        Cancelar
      </button>
      <button 
        (click)="saveCashRegister()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
        {{ isEditingCashRegister ? 'Actualizar' : 'Crear' }}
      </button>
    </div>
  </div>
</div>
